const STORAGE_KEY = 'stratform_response_attempt_diagnostics';
const MAX_EVENTS = 100;
const RETENTION_MS = 2 * 60 * 60 * 1000;

const createId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const purgeResponseAttemptDiagnostics = () => {
  try {
    const events = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    const cutoff = Date.now() - RETENTION_MS;
    const retainedEvents = Array.isArray(events)
      ? events.filter(event => Date.parse(event.occurred_at) >= cutoff).slice(-MAX_EVENTS)
      : [];
    if (retainedEvents.length) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(retainedEvents));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    return retainedEvents;
  } catch {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Local cleanup should not interrupt response submission.
    }
    return [];
  }
};

const readEvents = purgeResponseAttemptDiagnostics;

const writeEvents = (events) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(events.slice(-MAX_EVENTS)));
  } catch {
    // Diagnostics must never interrupt response submission.
  }
};

export const createResponseAttemptId = createId;

export const clearResponseAttemptDiagnostics = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Local cleanup should not interrupt logout.
  }
};

export const recordResponseAttemptDiagnostic = ({ userId, attemptId, formId, eventType, httpStatus, errorCode }) => {
  const events = readEvents();
  events.push({
    event_id: createId(),
    user_id: userId,
    attempt_id: attemptId,
    form_id: formId,
    event_type: eventType,
    occurred_at: new Date().toISOString(),
    ...(Number.isInteger(httpStatus) ? { http_status: httpStatus } : {}),
    ...(errorCode ? { error_code: errorCode } : {}),
  });
  writeEvents(events);
};

if (typeof window !== 'undefined') {
  purgeResponseAttemptDiagnostics();
}
